import PhysioList from "../pages/physio";
import PhysioSlots from "../pages/physio/slots";
import VideoSessionsList from "../pages/physio/video_sessions";
import DashboardPageLayout from "../layouts/dashboard_layout";
import { ProtectedRoutes } from "./protected_route";

const PhysioRoutes = {
    path: "/physio",
    element: (
        <ProtectedRoutes>
            <DashboardPageLayout />
        </ProtectedRoutes>
    ),
    children: [
        {
            path: "list",
            element: <PhysioList />,
        },
        {
            path: "slots/:userId",
            element: <PhysioSlots />,
        },
        {
            path: "video-sessions",
            element: <VideoSessionsList />,
        },
    ],
};

export default PhysioRoutes;
